var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 6v-.87a5.13 5.13 0 00-10.26 0V6H0v14h20V6zM6 5.13a4 4 0 018 0V6H6zM19 19H1V7h18z",
    fill: "#cca789"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48cGF0aCBkPSJNMTUuMTMsNlY1LjEzYTUuMTMsNS4xMywwLDAsMC0xMC4yNiwwVjZIMFYyMEgyMFY2Wk02LDUuMTNhNCw0LDAsMCwxLDgsMFY2SDZaTTE5LDE5SDFWN0gxOVoiIGZpbGw9IiNjY2E3ODkiLz48L3N2Zz4=";
export { SvgShoppingBag as ReactComponent };